import { Loader2 } from 'lucide-react';
import { cn } from '../../../lib/utils.js';

/**
 * Overlay shown over a canvas box (master solution, grading scheme, grading, student answer) while its
 * content is being (re)generated in the background. Mirrors the upload-in-progress overlay in
 * solution-panels.tsx's SectionContent so the two loading states read as the same visual language.
 */
export function BoxLoadingOverlay({ label, className }: { label: string; className?: string }) {
  return (
    <div
      className={cn(
        'absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded-md bg-white/70 dark:bg-slate-900/70 text-sm text-slate-600 dark:text-slate-300 pointer-events-none',
        className,
      )}
    >
      <Loader2 size={20} className="animate-spin" />
      <span>{label}</span>
    </div>
  );
}
